/**
 * @fileoverview Workspace Agent view — search bar + embedded chat
 *
 * Rendered at `/dashboard/agent`. Same shape as `JobAgentView` but
 * scoped to the active org and uses workspace-mode tools (fan-out
 * search across every accessible job).
 */

import { useState, useCallback, useEffect } from "react";
import type { Id } from "@cvx/_generated/dataModel";
import { UniversalChatPanel } from "./UniversalChatPanel";

export function WorkspaceAgentView({
  orgId,
  initialQuery,
}: {
  orgId: Id<"organizations">;
  /** Query forwarded from the Cmd+K palette via `?ask=...`. */
  initialQuery?: string;
}) {
  const [seedQuery, setSeedQuery] = useState<string | undefined>(undefined);

  const handleSeedConsumed = useCallback(() => setSeedQuery(undefined), []);

  // Consume `?ask=` on mount and whenever it changes (e.g. user is
  // already on this page and the Cmd+K palette navigates with a new query).
  useEffect(() => {
    if (initialQuery && initialQuery.trim().length > 0) {
      setSeedQuery(initialQuery.trim());
    }
  }, [initialQuery]);

  return (
    <div className="flex h-[calc(100vh-4rem)] flex-col overflow-hidden">
      <div className="flex min-h-0 flex-1 px-4 pb-4 pt-3 md:px-6">
        <UniversalChatPanel
          scope="workspace"
          orgId={orgId}
          seedMessage={seedQuery}
          onSeedConsumed={handleSeedConsumed}
          className="min-h-0 flex-1"
        />
      </div>
    </div>
  );
}
